'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dMeal$002dCourse$0024other from "./mealorama.-Meal-Course$other.js";
var $p;
/** @constructor */
function $c_Lmealorama_MealCourse$other$() {
}
export { $c_Lmealorama_MealCourse$other$ as $c_Lmealorama_MealCourse$other$ };
$p = $c_Lmealorama_MealCourse$other$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_MealCourse$other$;
/** @constructor */
function $h_Lmealorama_MealCourse$other$() {
}
export { $h_Lmealorama_MealCourse$other$ as $h_Lmealorama_MealCourse$other$ };
$h_Lmealorama_MealCourse$other$.prototype = $p;
$p.m = (function() {
  return "other";
});
$p.aSl = (function(x$0) {
  return new $j_mealorama$002e$002dMeal$002dCourse$0024other.$c_Lmealorama_MealCourse$other(x$0.g(0));
});
var $d_Lmealorama_MealCourse$other$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_MealCourse$other$, "mealorama.MealCourse$other$", ({
  Gd: 1,
  d: 1,
  e: 1
}));
export { $d_Lmealorama_MealCourse$other$ as $d_Lmealorama_MealCourse$other$ };
var $n_Lmealorama_MealCourse$other$;
function $m_Lmealorama_MealCourse$other$() {
  if ((!$n_Lmealorama_MealCourse$other$)) {
    $n_Lmealorama_MealCourse$other$ = new $c_Lmealorama_MealCourse$other$();
  }
  return $n_Lmealorama_MealCourse$other$;
}
export { $m_Lmealorama_MealCourse$other$ as $m_Lmealorama_MealCourse$other$ };
//# sourceMappingURL=mealorama.-Meal-Course$other$.js.map
